export const blogText = new Map([
  [
    "blog",
    {
      title: "Dicas, estratégias e novidades do mundo das loterias",
      breadCrumb: "",
      link: "",
      description:
        "Mantenha-se atualizado com as melhores estratégias, análises de resultados, histórias inspiradoras e tudo que você precisa saber para jogar com inteligência.",
    },
  ],
]);
